import { NgModule } from '@angular/core';
import { ModuloSolicitudesComponent } from './modulo-solicitudes.component';



@NgModule({
  declarations: [ModuloSolicitudesComponent],
  imports: [
  ],
  exports: [ModuloSolicitudesComponent]
})
export class ModuloSolicitudesModule { }
